module.exports = __webpack_public_path__ + "media/notre_mission/mobile_quote-1f2bf1ac.png";